import EventEmitter from 'eventemitter3';

const eventEmitter = new EventEmitter();

const Emitter = {
  on: (event: string | symbol, fn: EventEmitter.ListenerFn) => eventEmitter.on(event, fn),
  once: (event: string | symbol, fn: EventEmitter.ListenerFn) => eventEmitter.once(event, fn),
  off: (event: string | symbol, fn: EventEmitter.ListenerFn | undefined) => eventEmitter.off(event, fn),
  emit: (event: string | symbol, payload: any) => eventEmitter.emit(event, payload)
}

Object.freeze(Emitter);

export default Emitter;